import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';
import { Component, NgModule, OnInit, OnDestroy, Input, Output, EventEmitter, HostListener, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Risk } from 'app/shared/models/risk.model';
import { Subscription } from 'rxjs/Subscription';

import { Observable } from 'rxjs/Observable';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { WarmUpService } from 'app/services/warmup/warmup.service';

import { AddRiskComponent } from 'app/entities/transaction-profile/risks/addrisk/add-risk.component';
import { UpdateRiskComponent } from 'app/entities/transaction-profile/risks/updaterisk/update-risk.component';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import { Agreement } from 'app/entities/transaction-profile/agreement.model';

@Component({
    selector: 'risks',
    templateUrl: './risk.component.html'
})

export class RiskComponent implements OnInit, OnDestroy {
    @Input() entityIdDetails: EntityIdDetails;
    risks: Array<Risk>;
    dialogRef: MdDialogRef<any>;
    selectedRisk: Risk;
    risksLoaded = false;
    riskChance: ApplicationValue[];
    riskType: ApplicationValue[];
    riskImpact: ApplicationValue[];
    controlRiskChance = 'riskChance';
    controlRiskType = 'riskType';
    controlRiskImpact = 'riskImpact';
    selectedAgreement: Agreement;
    add = 'Add';
    edit = 'Edit';
    zeroAggrement = true;
    private subscriptions: Subscription[] = [];

    constructor(
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        private warmUpService: WarmUpService,
        private cdr: ChangeDetectorRef,
        private transactionProfileService: EntityTransactionProfileService,
        private snackBarService: SnackBarService) { }

    ngOnInit() {
        // Risk Chances from application values.
        this.setupControlValues(
            this.controlRiskChance, (this.warmUpService.getApplicationValue(ApplicationTypeConstants.ENTITY_RISK_CHANCE)));
        // Risk Types from application values.
        this.setupControlValues(this.controlRiskType, (this.warmUpService.getApplicationValue(ApplicationTypeConstants.ENTITY_RISK_TYPE)));
        // Risk Impacts from application values.
        this.setupControlValues(
            this.controlRiskImpact, (this.warmUpService.getApplicationValue(ApplicationTypeConstants.ENTITY_RISK_IMPACT)));
        this.setSelectedAgreementSubscriber();
    }

    loadRisks() {
        if (this.selectedAgreement) {
            if (this.entityIdDetails) {
                const subscription = this.transactionProfileService.getRisks(this.selectedAgreement.id)
                    .subscribe(response => {
                        if (response) {
                            this.risks = response;
                            for (const index in response) {
                                const riskChanceValue = this.getControlName(this.controlRiskChance, Number(response[index].netChance));
                                const riskTypeValue = this.getControlName(this.controlRiskType, Number(response[index].type));
                                const riskImpactValue = this.getControlName(this.controlRiskImpact, Number(response[index].netImpact));
                                this.risks[index][this.controlRiskChance] = riskChanceValue;
                                this.risks[index][this.controlRiskType] = riskTypeValue;
                                this.risks[index][this.controlRiskImpact] = riskImpactValue;
                            }
                            this.risksLoaded = true;
                        }
                    });
                this.subscriptions.push(subscription);
            }
        }
    }

    setupControlValues(control, dropDownValues: any) {
        if (dropDownValues instanceof Observable) {
            const subscription = dropDownValues.subscribe(
                response => {
                    this.warmUpService.setApplicationTypeInLS(response);
                    this[control] = response.values;
                    this.cdr.detectChanges();
                }
            );
            this.subscriptions.push(subscription);
        } else {
            this[control] = dropDownValues;
        }
    }

    // Get control type name
    getControlName(controlName, controlId: number) {
        let arrControl = [];
        if (controlName === this.controlRiskChance && this.riskChance) {
            arrControl = this.riskChance;
        } else if (controlName === this.controlRiskType && this.riskType) {
            arrControl = this.riskType;
        } else if (controlName === this.controlRiskImpact && this.riskImpact) {
            arrControl = this.riskImpact;
        }
        const returnRecord = arrControl.find(riskField => riskField.id === controlId);
        const returnName = returnRecord ? returnRecord.name : '';
        return returnName;
    }

    setSelectedAgreementSubscriber() {
        // Unsubscribe from previous subscription if it exists
        const existingSub = this.subscriptions.find(sub => sub && !sub.closed);
        if (existingSub) {
            existingSub.unsubscribe();
        }
        
        const subscription = this.transactionProfileService.selectedAgreement.subscribe(agreement => {
            if (agreement) {
                this.selectedAgreement = agreement;
                this.loadRisks();
                this.zeroAggrement = false;
            }else {
                this.risksLoaded = true;
            }
        });
        this.subscriptions.push(subscription);
    }

    openAddRiskDialog(action: string) {
        const config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddRiskComponent, config);
        this.dialogRef.componentInstance.agreementId = this.selectedAgreement.id;
        const subscription = this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadRisks();
            }
        });
        this.subscriptions.push(subscription);
    }

    openEditRiskDialog(riskRecord: Risk): void {
        const config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(UpdateRiskComponent, config);
        this.dialogRef.componentInstance.selectedRisk = riskRecord;
        this.dialogRef.componentInstance.agreementId = this.selectedAgreement.id;
        const subscription = this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadRisks();
            }
            this.dialogRef = null;
            this.selectedRisk = null;
        });
        this.subscriptions.push(subscription);
    }

    deleteRisk(riskRecord: Risk) {
        const subscription = this.transactionProfileService.removeRisk(riskRecord.id).subscribe(response => {
            this.callSnackBarService(response);
            this.loadRisks();
        }, err => {
            this.callSnackBarService(err);
        });
        this.subscriptions.push(subscription);
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.RISK_SUCCESS_TEMPLATE.replace('%s', 'deleted'),
            MessageService.RISK_FAILURE_TEMPLATE.replace('%s', 'delete'));
    }

    ngOnDestroy() {
        // Unsubscribe from all subscriptions to prevent memory leaks and duplicate calls
        this.subscriptions.forEach(sub => {
            if (sub && !sub.closed) {
                sub.unsubscribe();
            }
        });
        this.subscriptions = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/risks/risk.component.ts